import { Box, Typography } from '@material-ui/core'

import Button from '@/components/button'
import InputText from '@/components/input-text'
import { useCompanies } from '@/hooks/use-companies'

import { useStyles } from './styles'

interface HeaderProps {
  searchFolder: string
  handleSearchFolder: (value: string) => void
  showAddFolderModal: () => void
}

export const Header = ({
  searchFolder,
  handleSearchFolder,
  showAddFolderModal,
}: HeaderProps) => {
  const classes = useStyles()
  const { permissions } = useCompanies()

  return (
    <Box className={classes.actionBar}>
      <Typography variant={'h1'}>Pastas</Typography>
      <InputText
        id='search-input'
        label={'Buscar pastas...'}
        type='search'
        value={searchFolder}
        onChange={(e) => handleSearchFolder(e.target.value)}
      />
      {permissions?.createFolders && (
        <Button
          outlined
          className={classes.button}
          disabled={!permissions?.createFolders}
          onClick={showAddFolderModal}
        >
          Adicionar pasta
        </Button>
      )}
    </Box>
  )
}
